import React from 'react';
import { Navigate } from 'react-router-dom';
import { AdminDashboard } from './Dashboards.jsx';
import CoachToday from './CoachToday.jsx';
import ParentDashboard from './ParentDashboard.jsx';
import AthleteHome from './AthleteHome.jsx';
import { useAuth } from '../context/AuthContext.js';

function DashboardRouter({ athletes }) {
  const { user } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  switch (user.role) {
    case 'admin':
      return <AdminDashboard user={user} dashboardData={{}} />;
    case 'coach':
      return <CoachToday user={user} />;
    case 'parent':
      return <ParentDashboard />;
    case 'athlete':
      return <AthleteHome />;
    default:
      return (
        <div style={{ padding: 32, textAlign: 'center' }}>
          <h2>Welcome, {user.name}</h2>
          <p>Your role ({user.role}) does not have a default dashboard yet.</p>
        </div>
      );
  }
}

export default DashboardRouter;
